import React from 'react';
import Overlay from 'components/atoms/Overlay/Overlay';
import { useModalContext } from 'components/templates/ModalProvider/ModalProvider';
import Txt from 'components/atoms/Txt/Txt';
import { BLOG_POSTS, PAY_PAL } from '../pages';
import Button from 'components/atoms/Button/Button';
import classes from './CashoutProviderInfoModal.module.scss';
import { CashoutProvider } from './CashoutProviderButtons';

export interface Props {
  provider: CashoutProvider;
  name: string;
  onClose: () => void;
}

interface InfoProps {
  name: string;
}

const RequiresVerificationInfo: React.FC<InfoProps> = ({ name }) => (
  <>
    <Txt component="p">
      To be able to process your cashout, we first need you to verify your identity via PayPal. To
      do this verification, we need you to link &amp; cashout any amount to a PayPal account. After
      this, you&apos;ll be able to use {name} to receive your rewards.
    </Txt>
    <Txt component="p">
      If you have any issues, please reach out to{' '}
      <Txt component="a" href="mailto:support@qmee.com" target="_blank" rel="noreferrer">
        support@qmee.com
      </Txt>
      .
    </Txt>
    <Button component="a" href={PAY_PAL.path}>
      <Txt component="p">Cash out to PayPal</Txt>
    </Button>
  </>
);

const OfflineInfo: React.FC<InfoProps> = ({ name }) => (
  <>
    <Txt component="p">
      Cashouts to {name} are currently offline, and we are working to bring them back as soon as
      possible. Please check back later.
    </Txt>
  </>
);

const CashoutProviderInfoModal: React.FC<Props> = ({ provider, onClose, name }) => {
  const { hideModal } = useModalContext();
  const handleClose = () => {
    hideModal();
    onClose();
  };

  return (
    <Overlay onClose={handleClose} showClose>
      <div className={classes.modal}>
        <Txt component="h2">Cashout to {name}</Txt>
        {provider.status === 'REQUIRES_VERIFICATION' ? (
          <RequiresVerificationInfo name={name} />
        ) : (
          <OfflineInfo name={name} />
        )}
      </div>
    </Overlay>
  );
};

export default CashoutProviderInfoModal;
